import { TestStoreContext } from "@natklok/contexts/testStoreContext";
import { useContext } from "react";

const useIsMinimizedQuiz = () => {
  const { minimizedQuiz } = useContext(TestStoreContext);
  return minimizedQuiz;
};

export default useIsMinimizedQuiz;
